// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ndyiR","badges":"styles_badges__2miTJ"};